<lib-card>
  <lib-card-body>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <div class="row d-flex align-items-center mr-2">
          <span class="font-size-normal text-primary font-weight-bold mr-3">{{ pageTitle | translate }}</span>
        </div>

        @for (option of filterConfig?.sort(sortByOrder); track option; let last = $last) {
          <ng-template [ngTemplateOutlet]="this[option?.type]"></ng-template>
        }
      </div>

      @if (!hasFilters && isLoadingFilters) {
        <div class="row d-flex justify-content-around">
          <app-spinner></app-spinner>
        </div>
      }

      <div class="row d-flex align-items-center">
        @if (hasFilters) {
          <button [disabled]="!showReset" class="btn btn-default set-default-btn" (click)="resetFilters()">
            {{ 'KPI.COMMON.SET_DEFAULT' | translate }}
          </button>
        }
      </div>
    </div>
    @if (!hasFilters && !isLoadingFilters) {
      <div class="p-3 text-center">
        {{ 'COMMON.NO_DATA' | translate }}
      </div>
    }
  </lib-card-body>
</lib-card>


<ng-template #CHECK_BOXES_WITH_SEARCH>
  <div class="d-flex align-items-center mx-3">
    <lib-select
      id="processes-select"
      [options]="checkboxesWithSearchOptions"
      [border]="'custom-border'"
      [classes]="'font-size-normal-small text-primary'"
      [itemClasses]="'font-size-normal-small process-item'"
      [placeholder]="checkBoxesWithSearchConfig.inputPlaceHolder"
      [doNotTranslate]="true"
      [fullWidth]="true"
      [notBold]="true"
      [customAllLabel]="checkBoxesWithSearchConfig.allSelectedTitle"
      [itemClasses]="'font-size-normal-small'"
      [checkboxesMenu]="true"
      [showSelectedNames]="false"
      [autoClose]="'outside'"
      (selectedChanged)="checkBoxesSearch($event, checkBoxesWithSearchConfig)"
      (selectAllItems)="checkBoxesSelectAll($event, checkBoxesWithSearchConfig)">
    </lib-select>
  </div>
</ng-template>

<ng-template #CHECK_BOXES>
  <lib-select
    id="planning-analytics-filter-select"
    [options]="checkboxesOptions"
    [optionsColors]="checkboxesOptionsColor"
    [border]="'custom-border'"
    [classes]="'font-size-normal-small text-primary'"
    [itemClasses]="'font-size-normal-small process-item'"
    [doNotTranslate]="false"
    [fullWidth]="true"
    [notBold]="true"
    [customAllLabel]="checkBoxesConfig.allSelectedTitle"
    [checkboxesMenu]="true"
    [autoClose]="'outside'"
    (selectedChanged)="checkBoxesChange($event, checkBoxesConfig)"
    (selectAllItems)="checkBoxesSelectAll($event, checkBoxesConfig)">
  </lib-select>
</ng-template>


<ng-template #RADIO_GROUP_TEMPLATE>
  <div class="d-flex align-items-center mx-3">
    <span class="mr-2 align-self-center font-weight-bold text-primary">
      {{ radioGroupTemplateConfig?.panelTitle | translate }}
    </span>

    <mat-radio-group
      class="d-flex align-items-center adjusted-margin"
      [(ngModel)]="radioGroupTemplateConfig.optionsListSelected"
      (change)="radioGroupChange()">
      @for (status of radioGroupTemplateConfig.radioOptionsList; track status; let i = $index) {
        <div class="d-flex align-items-center">
          <mat-radio-button class="my-0 text-primary mx-1 custom-radio-button" [value]="i">
            {{ status | translate }}
          </mat-radio-button>
        </div>
      }
    </mat-radio-group>
  </div>
</ng-template>
